import { Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  CircularProgress,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputAdornment,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  FormHelperText,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { post } from "../../../src/services/http";
import { ContextSession } from "../../services/ContextSession";
import FilterListIcon from "@mui/icons-material/FilterList";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import CryptoJS from "crypto-js";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { useNavigate } from "react-router-dom";
import { Check as CheckIcon, Close as CloseIcon } from "@mui/icons-material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#19438C",
    color: "white",
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderRight: "none", // Elimina la línea vertical entre columnas
    borderLeft: "none", // Elimina la línea vertical entre columnas
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    // Agrega estilo al pasar el cursor sobre la fila
    backgroundColor: "#C1C1C1", // Cambia el color de fondo al pasar el cursor
  },
}));

function ListaUsuarios() {
  let sessi = useContext(ContextSession);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchTerm, setSearchTerm] = useState("");
  const [loanType, setLoanType] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [statusSolicitudFilter, setStatusSolicitudFilter] = useState("");
  const [filas, setFilas] = useState([]);
  const [searchDNI, setSearchDNI] = useState("");
  const handleSearchDNIChange = (event) => setSearchDNI(event.target.value);
  const navigate = useNavigate();

  async function getSolicitudes(token) {
    const url = `https://bei360.injupemp.gob.hn:8444/api/auth/list`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        // Si el token expiró (401 Unauthorized), redirigir al login
        if (response.status === 401) {
          const result = await response.json();
          if (result.code === "token_not_valid") {
            // Limpiar sesión y redirigir
            sessi.clearSession();
            navigate("/");
            return [];
          }
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data || []; // Asegurar que siempre devuelva un array
    } catch (error) {
      console.error("Error al obtener registros:", error);
      return []; // Devolver array vacío en caso de error
    }
  }

  useEffect(() => {
    async function fetchData() {
      try {
        let token = sessi.sessionData.token;
        const data = await getSolicitudes(token);
        setFilas(data);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [sessi.sessionData.token]);

  const handleClick = (id) => {
    sessi.setVariable("Users360Id", id);
    navigate("/UTI/ActualizarUsuarios360");
  };

  // Función para redirigir a la página de crear usuario
  const handleCreateUser = () => {
    navigate("/UTI/CrearUsuarios360"); // Cambia esta ruta por la correcta
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Reiniciar la página al cambiar el término de búsqueda
  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
    setPage(0); // Reinicia la página a la primera
  };

  const handleLoanTypeChange = (event) => {
    setLoanType(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const handleStatusSolicitudChange = (event) => {
    setStatusSolicitudFilter(event.target.value);
  };

  // Filtrar los datos según los criterios de búsqueda
  const filteredRows = filas.filter((row) => {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const lowerCaseSearchDNI = searchDNI.toLowerCase();

    // Filtro por estado (is_active)
    let estadoCoincide = true;
    if (statusFilter === "Activos") {
      estadoCoincide = row.is_active === true;
    } else if (statusFilter === "Inactivos") {
      estadoCoincide = row.is_active === false;
    }

    return (
      estadoCoincide &&
      (searchTerm === "" ||
        row.first_name?.toLowerCase().includes(lowerCaseSearchTerm) ||
        row.last_name?.toLowerCase().includes(lowerCaseSearchTerm) ||
        row.username?.toLowerCase().includes(lowerCaseSearchTerm) ||
        row.departamento?.toLowerCase().includes(lowerCaseSearchTerm)) &&
      (searchDNI === "" || row.id?.toString().includes(lowerCaseSearchDNI))
    );
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [filterType, setFilterType] = useState("");

  const handleFilterClick = (event, type) => {
    setAnchorEl(event.currentTarget);
    setFilterType(type);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    setFilterType("");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div className="container" style={{ marginTop: 10 }}>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "200px",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: 10,
            }}
          >
            <h2>
              <b>Lista de Usuarios</b>
            </h2>
          </div>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              flexWrap: "wrap",
              mb: 2,
              mt: 1,
              justifyContent: "center", // <--- Cambia aquí
            }}
          >
            <FormControl size="small" sx={{ minWidth: 170 }}>
              <FormHelperText>Filtrar por Estado</FormHelperText>
              <Select
                value={statusFilter}
                onChange={(e) => {
                  setStatusFilter(e.target.value);
                  setPage(0);
                }}
                displayEmpty
                fullWidth
              >
                <MenuItem value="">Todos los Usuarios</MenuItem>
                <MenuItem value="Activos">Activos</MenuItem>
                <MenuItem value="Inactivos">Inactivos</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box
            display="grid"
            gridTemplateColumns="1fr auto"
            alignItems="center"
            mt={2}
            px={3}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<PersonAddIcon />}
              onClick={handleCreateUser}
              sx={{
                borderRadius: "8px",
                padding: "8px 16px",
                fontWeight: "bold",
                justifySelf: "end", // Alinea el botón a la derecha
              }}
            >
              Crear Nuevo Usuario
            </Button>
          </Box>
          <div className="row" style={{ marginTop: "20px" }}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <StyledTableRow>
                    {/* <StyledTableCell>#</StyledTableCell> */}
                    <StyledTableCell>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <strong>Usuario</strong>
                        <Tooltip title="Buscar por Usuario" arrow>
                          <IconButton
                            onClick={(event) =>
                              handleFilterClick(event, "search")
                            }
                          >
                            <ManageSearchIcon style={{ color: "white" }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <strong>Nombres</strong>
                        <Tooltip title="Buscar por Nombre" arrow>
                          <IconButton
                            onClick={(event) =>
                              handleFilterClick(event, "search")
                            }
                          >
                            <ManageSearchIcon style={{ color: "white" }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <strong>Apellidos</strong>
                        <Tooltip title="Buscar por Apellido" arrow>
                          <IconButton
                            onClick={(event) =>
                              handleFilterClick(event, "search")
                            }
                          >
                            <ManageSearchIcon style={{ color: "white" }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>Email</StyledTableCell>
                    {/*<StyledTableCell>Ubicación</StyledTableCell>*/}
                    {/* <StyledTableCell>Departamento</StyledTableCell> */}
                    <StyledTableCell>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <strong>Departamento</strong>
                        <Tooltip title="Buscar por Departamento" arrow>
                          <IconButton
                            onClick={(event) =>
                              handleFilterClick(event, "search")
                            }
                          >
                            <ManageSearchIcon style={{ color: "white" }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </StyledTableCell>
                    {/* <StyledTableCell>Celular</StyledTableCell> */}
                    <StyledTableCell>Estado</StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      Acciones
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>

                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleFilterClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  {filterType === "search" && (
                    <TextField
                      placeholder="Buscar Usuario"
                      aria-label="Buscar Usuario"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                  {filterType === "searchDNI" && (
                    <TextField
                      placeholder="Buscar por DNI"
                      aria-label="Buscar por DNI"
                      value={searchDNI}
                      onChange={handleSearchDNIChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </Popover>
                <TableBody>
                  {filteredRows.length > 0 ? (
                    (rowsPerPage > 0
                      ? filteredRows.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : filteredRows
                    ).map((row, index) => (
                      <StyledTableRow key={row.id}>
                        {/* <StyledTableCell>{row.id}</StyledTableCell> */}
                        <StyledTableCell>{row.username}</StyledTableCell>
                        <StyledTableCell>{row.first_name}</StyledTableCell>
                        <StyledTableCell>{row.last_name}</StyledTableCell>
                        <StyledTableCell>{row.email}</StyledTableCell>
                        <StyledTableCell>{row.departamento}</StyledTableCell>
                        {/* <StyledTableCell>{row.celular}</StyledTableCell> */}
                        <StyledTableCell>
                          <Box
                            sx={{
                              backgroundColor: row.is_active ? "green" : "red",
                              color: "white",
                              borderRadius: "8px",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "30px",
                              height: "30px",
                              userSelect: "none",
                              WebkitUserSelect: "none",
                              MozUserSelect: "none",
                              cursor: "pointer", // Solo si usas tooltip
                            }}
                          >
                            {row.is_active ? <CheckIcon /> : <CloseIcon />}
                          </Box>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Box display="flex" justifyContent="center">
                            <IconButton onClick={() => handleClick(row.id)}>
                              <VisibilityIcon sx={{ color: "green" }} />
                            </IconButton>
                          </Box>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell
                        colSpan={12}
                        style={{ textAlign: "center" }}
                      >
                        No se encontraron datos
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {filteredRows.length > 0 && (
              // El componente de paginación ya usa `filteredRows.length` dinámicamente
              <TablePagination
                rowsPerPageOptions={[25, 35, 50]}
                component="div"
                count={filteredRows.length} // Longitud dinámica basada en la búsqueda
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                labelRowsPerPage={"Filas por página"}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default ListaUsuarios;
